import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { ColDef, IServerSideGetRowsParams } from "ag-grid-community";
import { Subscription } from "rxjs";
import { InventoryService } from "src/app/_services/inventory.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { TableHeaderToolTipComponent } from "../table-header-tool-tip/table-header-tool-tip.component";
import { ServerRequest } from "src/app/_models/global.data.model";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';
import moment from 'moment';
import { AuthenticationService } from "src/app/auth/authentication.service";
var dateFormateChange: any;
var router: Router

@Component({
    selector: 'app-custella-transfer',
    templateUrl: './custella-transfer.component.html',
    styleUrls: ['./custella-transfer.component.scss'],
    standalone: false
})
export class CustellaTransferComponent extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  @Output() selecetedBinEvent = new EventEmitter();
  @Output() closeView = new EventEmitter();
  @Input() selectedFromBinId: any=null;
  @Input() parentType: any=null;

  gridApi: any;
  gridColumnApi: any;
  columnDefs: any = [];
  defaultColDef: any;
  frameworkComponents: any;
  gridParams: any;
  startFrom: any;
  product: any;
  pageSize: any = 25;
  parameters: any;
  gridOptions:any 
  overlayNoRowsTemplate!: string;

  binTransferData: any;
  actionData: any;
  totalRecord: any;
  currentRecordNumber: any;
  refresher!: Subscription;
  searchValue: any = "";

  noData: null | boolean = null;
  translate: any;

  constructor(
    private inventoryService: InventoryService,
    private errorUtil: ErrorUtil,
    private languageTranslateService: LanguageTranslateService,
    private spinner: NgxSpinnerService,
    private auth: AuthenticationService,
  ) {
    super();
    // this.languageTranslateService.menuSrc$.subscribe(data => {
    //   if(Object.keys(data).length != 0){ this.translate = data}
    // })
    this.preInit();
  }

  ngOnInit() {
     dateFormateChange = this.auth.getUserTimezone();

    this.init();
  }
dateFormateChange(params: any) {
    // console.log(params)
     if(params.data){ 
       if(params.data.transferredAt !== undefined){ 
        //console.log(params.data.transferredAt,"======")
      var dateFormat : any =localStorage.getItem('date_format')
         return moment.tz(params.data.transferredAt, dateFormateChange).format(' hh:mm A ' +dateFormat.toUpperCase()) ;
       }
     }
  
   }
  ngOnDestroy() {
    super.ngOnDestroy();
  }

  private preInit() {
    this.gridOptions = {
      cacheBlockSize: 25,
      rowModelType: "infinite",
      sortingOrder: ["desc", "asc"],
      tooltipShowDelay: 100,
      onGridSizeChanged: (params:any) => {
        params.api.sizeColumnsToFit();
      },
    };

    this.defaultColDef = {
      enableRowGroup: false, //ag-Grid-Enterprise
      enablePivot: false, //ag-Grid-Enterprise
      enableValue: true, //ag-Grid-Enterprise
      sortable: true,
      resizable: true,
      filter: false,
      tooltipComponent: TableHeaderToolTipComponent,
    };

    // this.overlayNoRowsTemplate =
    //   "<div class='not-found'><span>{{'general.messages.noRecordsFound'}}</span> </div>";
  }

  private init() {
   this.getLanguageData()
  }

  /********************************** Search Data **************************/
  quickSearch() {
    this.onGridReady(this.gridParams);
  }
  /********************************** View Singal Record **************************/
  onGridReady(params: any) {
    //console.log(params)
    if (params != undefined) {
      this.gridParams = params;

      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();
      var dataSource = {
        getRows: (params: IServerSideGetRowsParams) => {
          this.getServerSideData(params);
        },
      };

      this.gridApi.sizeColumnsToFit();
      this.gridApi.setGridOption("datasource", dataSource);
    }
  }

  /********************************** Call Customer API to Display data **************************/
  getServerSideData(agGridGetRowsParams: IServerSideGetRowsParams) {
    // this.spinner.show()
    this.gridApi.hideOverlay();
    const serverRequest = this.getRequestParams(agGridGetRowsParams);

   this.inventoryService.getAllBinTransfer(this.searchValue, serverRequest ,null).subscribe((data: any) => {
           console.log(data.status,"=====>>>>>",data)
           if(data.status === 200 || data.status === 201){  
           this.binTransferData = data.body.data;
            this.totalRecord = data.body.total

            this.setGridData(agGridGetRowsParams, this.binTransferData, data.body.total,data.body.status);
            this.spinner.hide();
          }else{
            const title = this.errorUtil.processErrorTitle(data.error, this.translate)
            this.errorUtil.setErrorMessage(400, null, title, 'error', 3000);
            this.spinner.hide();
          }
        }, (err) => {
          console.log(err)
          const title = this.errorUtil.processErrorTitle(err.error, this.translate)
          this.errorUtil.setErrorMessage(400, null, title, 'error', 3000);
          this.spinner.hide();
        } )
  }

  /********************************** Set Data for Grid Table **************************/
  private setGridData(
    agGridGetRowsParams: IServerSideGetRowsParams,
    resultItems: any[],
    totalCount: number,
    status: string
  ) {
    console.log(resultItems, "===");

    if (status === "NO_DATA") {
      this.noData = true;

      this.gridApi.showNoRowsOverlay();
    } else {
      this.noData = false;

      if (this.binTransferData.length === 0) {
        this.gridApi.showNoRowsOverlay();
      } else {
        agGridGetRowsParams.success({rowData: this.binTransferData, rowCount: totalCount});
       ///CS-4758 this.gridApi.sizeColumnsToFit();
      }
    }
  }
  /********************************** Request Parameter for api **************************/

  getRequestParams(agGridRequest: any): ServerRequest {
    if (agGridRequest.sortModel.length <= 0) {
      this.parameters = { colId: "id", sort: "desc" };
      agGridRequest.sortModel.push(this.parameters);
    }

    //console.log(agGridRequest)
    this.currentRecordNumber = agGridRequest.startRow;
    return {
      startRow: agGridRequest.startRow,
      pageSize: 25,
      filterModel: null,
      sortModel: agGridRequest.sortModel,
    };
  }
  /********************************** View Singal Record **************************/

  selectLocationBinData(e: any) {
    this.selectLocationBin(e.data);
  }
  selectLocationBin(val: any) {
    this.selecetedBinEvent.emit(val);
  }

  closeBin() {
    this.closeView.emit(false);
  }

  push(obs: any) {
    super.push(obs);
  }

  getLanguageData() {
   // this.spinner.show()
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => { 
        if(Object.keys(data).length != 0){
          this.translate = data
          this.overlayNoRowsTemplate = "<div class='not-found'><span>"+this.translate?.general.messages.noRecordsFound+"</span> </div>";
         this.initializeColumns()
        }
      }))
    console.log("translate",this.translate)
    //this.mainLabel = this.translate?.site.label.plural
  }
  
initializeColumns() {
     this.columnDefs = []
    this.overlayNoRowsTemplate = "<div class='not-found'><span>"+this.translate?.general.messages.noRecordsFound+"</span> </div>";
   // console.log("initiateCol", this.translate, "=======", this.columnDefs)
    var newData  = [
      { headerName: this.translate?.binTransfer.fields.transferNo.singular, field: 'transferNumber', width: 100, cellClass: function (params : any) { return ['table_default_color'];}, headerTooltip: "#", },
      { headerName: this.translate?.binTransfer.fields.transferredBy.singular, field: 'requestedBy.fullName', width: 150, headerTooltip: "#", },
      { headerName: this.translate?.binTransfer.fields.fromBin.singular, field: 'fromBinDisplayName', width: 100, headerTooltip: "#",},
      { headerName: this.translate?.binTransfer.fields.toBin.singular, field: 'toBinDisplayName', width: 100,
      headerTooltip: "#",
      cellRenderer: function (params : any) {
        if(params.data){
          if(params.data.toBinDisplayName == null){
            return  params.data.jobOrderNumber
          }else{
            return  params.data.toBinDisplayName
          }
        }
      }
     },
      { headerName: this.translate?.binTransfer.fields.transferredDateTime.singular,  field: 'transferredAt', width: 200, valueFormatter:this.dateFormateChange, headerTooltip: "#", },
      { headerName: this.translate?.binTransfer.fields.approvalStatus.singular, field: 'approvalStatus', width: 100 , cellStyle: { "text-align": "center" }, headerClass: 'marging-auto hide-action-border',
      headerTooltip: "#",
      cellRenderer:(params : any)=>{
          if(params.data){
            if(params.data.approvalStatus =='CANCEL'){
            return '<span class="p-mr-2 p-tag-warning p-tag p-component"><span class="p-tag-value">'+this.translate.general.status.cancelled.singular+'</span></span>'
           }else  if(params.data.approvalStatus =='ACCEPTED'){
              return  ' <span class="p-mr-2 p-tag-success p-tag p-component"><span class="p-tag-value">'+this.translate.general.status.accepted.singular+'</span></span>'
            }else  if(params.data.approvalStatus =='PENDING'){
              return ' <span class="p-mr-2 p-tag-info p-tag p-component"><span class="p-tag-value">'+this.translate.general.status.pending.singular+'</span></span>';
            }else  if(params.data.approvalStatus =='DECLINED'){
              return ' <span class="p-mr-2 p-tag-danger p-tag p-component"><span class="p-tag-value">'+this.translate.general.status.declined?.singular ? this.translate.general.status.declined?.singular : 'Declined'+'</span></span>';
          }
        }
        }
      },
     
    ];

    this.columnDefs = newData;
    if (this.gridApi) {
      this.gridApi.setColumnDefs(this.columnDefs);
      setTimeout(() => { this.gridApi.sizeColumnsToFit(); },500);
    }
  }
}
